import { Component, OnInit } from '@angular/core';
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { FormsModule } from '@angular/forms';
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-alert-list',
  templateUrl: './alert-list.component.html',
  styleUrls: ['./alert-list.component.scss'],
  standalone: true,
  imports: [MatToolbarModule,CommonModule,FormsModule,MatFormFieldModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,ReactiveFormsModule]
})
export class AlertListComponent implements OnInit {
 
  public alertBaseUrl = BaseUrlConstantsService.BASE_ALERT_SYSTEM_URL;
  public today: any;
  public loading = false;
  public macAddress: string
  public serialNumber: string
  public companyName: string
  public siteName: string
  public apllicationName: string
  public assetName: string
  public applicationName: string
  public filteredData =[]
  isFiltered: boolean = false; // Flag to track if the data is filtered

  public selectedPeriod: string = 'today'; // Default value set to 'today'
  public alertList: any = []
  public isLoading : boolean = true; // Flag to track if
  public isAdmin: boolean = true;
  constructor( private service: BackendApiService) { }

  public breadcrumbsArray: any = [
    {
      page_ref: "/",
      page_title: "Alerts",
    },
  ];
  company_name=''

  activeIndex: number = -1;
  activeInnerIndex: number = -1;
  activeClientIndex: number = -1; // Track which client is expanded
  activeAlertId: string | null = null; // Track which alert is expanded

 

 


toggleClientDetails(index: number): void {
  this.activeClientIndex = this.activeClientIndex === index ? -1 : index;
  this.activeAlertId = null; // Collapse any expanded alert when switching clients
  this.activeInnerIndex =  -1 
  this.activeIndex =  -1 
}

toggleAlertDetails(alertId: string): void {
  this.activeAlertId = this.activeAlertId === alertId ? null : alertId;
}
  toggleDetails(index: number): void {
    this.activeIndex = this.activeIndex === index ? -1 : index;
    // this.activeInnerIndex = -1
    // console.log(this.activeInnerIndex, this.activeIndex)
  }
  selectedAlert: any;

openModal(detail: any,subidx) {
  this.selectedAlert = detail;
  this.activeIndex = this.activeIndex === subidx ? -1 : subidx;
}

closeModal() {
  this.selectedAlert = null;
  this.activeIndex = -1;
}
  toggleInnerDetails(index: number): void {
    this.activeInnerIndex = this.activeInnerIndex === index ? -1 : index;
    this.activeIndex =  -1
    //  console.log(this.activeInnerIndex, this.activeIndex)
  }
  ngOnInit(): void {
    this.utcTime() 
    let role = localStorage.getItem('role');
    if(role === 'ADMIN'){
      this.isAdmin = true;
    }else{
      this.isAdmin = false;
    }
    this.company_name = localStorage.getItem('company_name');
    this.fetchData("today");
   
  }

  public processedData: any = []; // Processed data array

  // https://devapi.enertics.ca/alerts/alert/all/2/monthly
  fetchData(selectedPeriod) {
    let endpoint = ``;
    let clientId = "";
    
    let role = localStorage.getItem('role');
    if (this.isAdmin) {
      clientId = localStorage.getItem('admin_client_id'); // Admin can access multiple clients' data
      endpoint = `${this.alertBaseUrl}alert/all/${selectedPeriod}`;
    } else if (!this.isAdmin && role !== 'USER') {
      clientId = localStorage.getItem('user_id'); // Client can access only their own data
       endpoint = `${this.alertBaseUrl}alert/all/${clientId}/${selectedPeriod}`;
  
    }else{
      clientId = localStorage.getItem('associated_clientid'); // Client can access only their own data
       endpoint = `${this.alertBaseUrl}alert/all/${clientId}/${selectedPeriod}`;
    }
  
  //  console.log(endpoint);
  
    this.service.getDataV2(endpoint).then((res) => {
      const response = JSON.parse(JSON.stringify(res));
      if (response.status == "success" ) {
        
        if (response?.data?.body?.alerts) {
        
           this.processedData = response.data.body.alerts;
          
          // console.log(this.processedData)
          this.isFiltered = false;
          this.isLoading = false;
        } else {
          this.processedData = [];
          this.isFiltered = false;
          this.isLoading = false;
          // this.service.showError("Something went wrong");
        }
      } else {
        this.service.showError("Something went wrong");
      }
    });
  }
  


    // Con
    convertUTCtoIST(utcDateString: string): Date {
      const utcDate = new Date(utcDateString);
      if (isNaN(utcDate.getTime())) {
        throw new Error('Invalid UTC date string');
      }
  
      // IST Offset (5 hours and 30 minutes)
      const istOffsetHours = 0;
      const istOffsetMinutes = 0;
  
      // Add the IST offset to the UTC date
      utcDate.setHours(utcDate.getHours() + istOffsetHours);
      utcDate.setMinutes(utcDate.getMinutes() + istOffsetMinutes);
  
      return utcDate; // Return the updated date in IST
    }

    searchBySiteName(value: string) {
      if (!this.processedData) {
        return
      }
    
      let filterData;
    
      if (this.isAdmin) {
        // Admin logic: Return the entire object where any alert matches the MAC address
        filterData = this.processedData.filter(client => 
          client.alerts.some(alert => alert.site_name.includes(value))
        );
      } else {
        // Client logic: Return only the matching alerts within each client
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.site_name.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); // Only include clients with matching alerts
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }
    searchByApplicationName(value: string) {
      if (!this.processedData) {
      return
      }
    
      let filterData;
    
      if (this.isAdmin) {
        // Admin logic: Return the entire object where any alert matches the MAC address
        filterData = this.processedData.filter(client => 
          client.alerts.some(alert => alert.application_name.includes(value))
        );
      } else {
        // Client logic: Return only the matching alerts within each client
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.application_name.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); // Only include clients with matching alerts
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }

    searchByAssetName(value: string) {
      if (!this.processedData) {
      return
      }
   
      let filterData;
    
      if (this.isAdmin) {
        
        filterData = this.processedData.filter(client => 
          client.alerts.some(alert => alert.asset_name.includes(value))
        );
      } else {
       
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.asset_name.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); 
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }
    searchByCompanyName(value: string) {
      if (!this.processedData) {
      return
      }
    
      let filterData;
    
      if (this.isAdmin) {
        // Admin logic: Return the entire object where any alert matches the MAC address
        filterData = this.processedData.filter(client => 
          client.client_name.includes(value)
        );
      } else {
        // Client logic: Return only the matching alerts within each client
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.client_name.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); // Only include clients with matching alerts
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }

    searchByMacAddress(value: string) {
      if (!this.processedData) {
      return
      }
    
      let filterData;
    
      if (this.isAdmin) {
        // Admin logic: Return the entire object where any alert matches the MAC address
        filterData = this.processedData.filter(client => 
          client.alerts.some(alert => alert.mac_address.includes(value))
        );
      } else {
        // Client logic: Return only the matching alerts within each client
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.mac_address.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); // Only include clients with matching alerts
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }
    
    searchBySerialNumber(value: string) {
      if (!this.processedData) {
      return
      }
    
      let filterData;
    
      if (this.isAdmin) {
        // Admin logic: Return the entire object where any alert matches the serial number
        filterData = this.processedData.filter(client => 
          client.alerts.some(alert => alert.device_serial_no.includes(value))
        );
      } else {
        // Client logic: Return only the matching alerts within each client
        filterData = this.processedData
          .map(client => ({
            ...client,
            alerts: client.data.filter(alert => alert.device_serial_no.includes(value)),
          }))
          .filter(client => client.alerts.length > 0); // Only include clients with matching alerts
      }
    
      if (filterData.length !== 0) {
        this.filteredData = filterData;
        this.isFiltered = true;
      } else {
        this.filteredData = [];
        this.isFiltered = true;
      }
    }
    
    
    

    onPeriodChange() {
      this.isLoading= true
      this.fetchData(this.selectedPeriod);
      // console.log('Selected period:', this.selectedPeriod);
      
    }


    formatDate(inputDate: string): string {
      try {
        const istDate = this.convertUTCtoIST(inputDate);
        const is12HourFormat: boolean = true;
        const year = istDate.getFullYear(); // IST Year
        const month = String(istDate.getMonth() + 1).padStart(2, "0"); // IST Month
        const day = String(istDate.getDate()).padStart(2, "0"); // IST Day
  
        let hours: number = istDate.getHours(); // IST Hours
        const minutes: string = String(istDate.getMinutes()).padStart(2, "0"); // IST Minutes
        const seconds: string = String(istDate.getSeconds()).padStart(2, "0"); // IST Seconds
  
        // Determine AM/PM if 12-hour format is required
        let ampm: string = "";
        if (is12HourFormat) {
          ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12; // Convert to 12-hour format
          if (hours === 0) {
            hours = 12; // Midnight case
          }
        }
  
        // Format the date
        const formattedDate = is12HourFormat
          ? `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`
          : `${day}/${month}/${year} ${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`;
  
        return formattedDate;
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid date format';
      }
    }
  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
}
